var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"document-form"},[_c('div',{staticClass:"form-item"},[_c('span',[_vm._v("Policyholder HKID")]),_c('file-container',{attrs:{"edit":true,"fileData":_vm.formData.id_type_pic,"otherData":{
        target: 'id_type_pic'
      },"titleName":"Policyholder HKID"},on:{"delete":_vm.handlerDeleteFile,"uploadSuccess":_vm.handlerUploadSuccess}})],1),_c('div',{staticClass:"form-item"},[_c('span',[_vm._v("Insured Student HKID")]),_c('file-container',{attrs:{"edit":true,"fileData":{
        thumb_url:_vm.student_info.id_type_pic_thumb_url,
        url:_vm.student_info.id_type_pic_url,
        client_name:_vm.student_info.id_type_pic_path_id
      },"otherData":{
        target: 'student_id_type_pic',
        type: 'student_id_type_pic'
      },"titleName":"Insured Student HKID"},on:{"delete":_vm.handlerDeleteFile,"uploadSuccess":_vm.handlerUploadSuccess}})],1),(_vm.hasAcc)?_c('div',{staticClass:"form-item"},[_c('span',[_vm._v("Accompanying Parent or Guardian HKID")]),_c('file-container',{attrs:{"edit":true,"fileData":{
        thumb_url:_vm.acc_parent_info.id_type_pic_thumb_url,
        url:_vm.acc_parent_info.id_type_pic_url,
        client_name:_vm.acc_parent_info.id_type_pic_path_id
      },"otherData":{
        target: 'acc_parent_id_type_pic  ',
        type: 'acc_parent_id_type_pic  '
      },"titleName":"Accompanying Parent or Guardian HKID"},on:{"delete":_vm.handlerDeleteFile,"uploadSuccess":_vm.handlerUploadSuccess}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }